import React from "react"
import PropTypes from "prop-types"
import SideNav from './SideNav'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'

class TopNav extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      menuOpen: false,
    }
    this.toggleMenu = this.toggleMenu.bind(this)

  }

  toggleMenu() {
    this.setState({
      menuOpen: !this.state.menuOpen,
    })
  }


  render() {
    return(
      <header className="header_banner">
        <div className="logo_blue" onClick={() => window.location.replace('/home')}></div>
        <div className="menu_right">
          <FontAwesomeIcon
            onClick={() => this.toggleMenu()}
            icon={faBars}
            className="hamburgerMenu"
            style={{color: '#03A9F4', fontSize: 20, marginRight: 10}}
          />
        </div>
        {this.state.menuOpen  &&
          <SideNav
            currentUserSlug={this.props.currentUserSlug}
            currentUserAvatar={this.props.currentUserAvatar}
            premiumUser={this.props.premiumUser}
            logout={this.props.logout}
            toggleMenu={this.toggleMenu}
          />}
      </header>
    )
  }



}

export default TopNav
